import { Form } from '@anytag/shared-atoms';
import { TikTokSignupFormRegisteredSchema } from './schema';
import { Template } from './Template';
import { TikTokSignupFormRegisteredProps, TikTokSignupFormRegisteredValues } from './types';

export const TikTokSignupFormRegistered = ({ onSubmit, defaultValues }: TikTokSignupFormRegisteredProps) => (
  <Form.Provider
    onSubmit={onSubmit}
    zodSchema={TikTokSignupFormRegisteredSchema}
    values={defaultValues as TikTokSignupFormRegisteredValues}
  >
    <Template />
  </Form.Provider>
);

export { type TikTokSignupFormRegisteredValues };
